<template>
  <div>
    <c-card title="공정 상세" class="cardClassDetailForm">
      <template slot="card-detail">
        <div class="col-12">
          <c-text
            :editable="false"
            :disabled="true"
            label="공정명"
            name="processName"
            v-model="popupParam.process.processName" />
        </div>
        <div class="col-6">
          <c-text
            :editable="false"
            :disabled="true"
            label="팀명(반)"
            name="assessDeptName"
            v-model="popupParam.process.assessDeptName"
          />
        </div>
        <div class="col-6">
          <c-text
            :editable="false"
            :disabled="true"
            label="원(재)료"
            name="mainMaterial"
            v-model="popupParam.process.mainMaterial"
          />
        </div>
        <div class="col-6">
          <c-text
            :editable="false"
            :disabled="true"
            type="number"
            label="근로자수(명)"
            name="workerCnt"
            v-model="popupParam.process.workerCnt"
          />
        </div>
        <div class="col-6">
          <c-text
            :editable="false"
            :disabled="true"
            label="생산품(기종)"
            name="productName"
            v-model="popupParam.process.productName"
          />
        </div>
      </template>
    </c-card>
    <c-card title="기타 안전보건상 정보" class="cardClassDetailForm">
      <template slot="card-detail">
        <div class="col-12">
          <c-accident
            :editable="editable"
            multiple
            :disabled="true"
            label="최근 3년간 재해발생사례"
            name="accidentHistoryDesc"
            v-model="popupParam.process.accidentHistoryDesc"
          />
        </div>
        <div class="col-12">
          <c-accident
            :editable="editable"
            :disabled="true"
            :isNear="true"
            multiple
            label="아차사고사례"
            name="nearMissDesc"
            v-model="popupParam.process.nearMissDesc"
          />
        </div>
        <div class="col-12">
          <c-checkbox
            :editable="editable"
            codeGroupCd="MDM_PROCESS_WORKER_TYPE_CD"
            :disabled="true"
            :isArray="false"
            label="근로자 구성 및 경력특성"
            name="workerTypeCd"
            itemText="codeName"
            itemValue="code"
            v-model="popupParam.process.workerTypeCd"
          />
        </div>
        <div class="col-6">
          <c-checkbox
            :editable="editable"
            codeGroupCd="MDM_PROCESS_TRANSPORT_TYPE_CD"
            type="edit"
            :disabled="true"
            :isArray="false"
            itemText="codeName"
            itemValue="code"
            name="heavyTransportTypeCd"
            label="중량물 운반수단"
            v-model="popupParam.process.heavyTransportTypeCd"
          />
        </div>
        <div class="col-6">
          <c-text
            :disabled="true"
            :editable="editable"
            label="장비명"
            name="heavyTransportEquip"
            v-model="popupParam.process.heavyTransportEquip"
          />
        </div>
        <div class="col-6">
          <c-checkbox
            :editable="editable"
            :disabled="true"
            :isFlag="true"
            label="교대작업 유무"
            name="shiftFlag"
            v-model="popupParam.process.shiftFlag"
          />
        </div>
        <div class="col-6">
          <c-checkbox
            :editable="editable"
            :disabled="true"
            :isFlag="true"
            label="중량물 인력취급유무"
            name="heavyManualFlag"
            v-model="popupParam.process.heavyManualFlag"
          />
        </div>
        <div class="col-12">
          <c-checkbox
            :editable="editable"
            codeGroupCd="MDM_PROCESS_HANDLING_TYPE_CD"
            type="edit"
            itemText="codeName"
            :disabled="true"
            :isArray="false"
            itemValue="code"
            name="heavyManualTypeCd"
            label="취급형태(들기/밀기/끌기)"
            v-model="popupParam.process.heavyManualTypeCd"
          />
        </div>
        <div class="col-6">
          <c-checkbox
            :editable="editable"
            :disabled="true"
            :isFlag="true"
            label="작업환경측정 실시"
            name="workEnvMeasureFlag"
            v-model="popupParam.process.workEnvMeasureFlag"
          />
        </div>
        <div class="col-6">
          <c-text
            :disabled="true"
            :editable="editable"
            label="노출초과인자/수치"
            name="exposureOverValue"
            v-model="popupParam.process.exposureOverValue"
          />
        </div>
        <div class="col-12">
          <c-checkbox
            :editable="editable"
            codeGroupCd="RAM_RISK_PROCESS_SPECIAL_EDU_TARGET_CD"
            type="edit"
            :disabled="true"
            :isArray="false"
            itemText="codeName"
            itemValue="code"
            name="specialEduTargetCd"
            label="특별안전보건교육 해당"
            v-model="popupParam.process.specialEduTargetCd"
          />
        </div>
      </template>
    </c-card>
    <c-table
      ref="table"
      class="q-mt-sm q-mb-xl q-pb-xl"
      title="공정별 작업 시나리오"
      :merge="grid.merge"
      :columns="grid.columns"
      :data="popupParam.process.fmScenarios"
      :editable="editable&&!popupParam.disabled"
      gridHeightAuto
      :isTitle="true"
      :filtering="false"
      :columnSetting="false"
      :usePaging="false"
      :hideBottom="true"
    >
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name==='customCol'">
          <component
            :is="imprComponent"
            :col="col"
            :props="props"
            :inputEditable="editable&&!popupParam.disabled"
            :isImmShow="true"
            :requestContentsCols="requestContentsCols"
            tableKey="ram4mAssessScenarioId"
            ibmTaskTypeCd="ITT0000023"
            ibmTaskUnderTypeCd="ITTU000030"
            @imprChange="imprChange"
          >
            <template v-slot:customArea="{ props }">
              <c-card title="시나리오 정보" class="cardClassDetailForm">
                <template slot="card-detail">
                    <div class="col-12 row" style="margin-top: -32px !important">
                      <template v-for="(item, idx) in customReadOnlyCols">
                        <div v-if="isGroupStart(idx)" :key="'group-'+idx" class="col-12 scenario-group-title">
                          {{item.group === 'A' ? '개선 전' : '개선 후'}}
                        </div>
                        <div :key="idx" :class="item.colClass">
                          <div class="mini-dailog-title">
                            <q-icon name="keyboard_arrow_right" size="xs" color="grey-8" />{{item.label}}
                          </div>
                          <div v-if="props.row[item.name]" class="border-content-dialog">
                            {{props.row[item.name]}}
                          </div>
                          <div v-else class="border-nocontent-dialog">
                            {{'No Data'}}
                          </div>
                        </div>
                      </template>
                      <div class="mini-dailog-title" style="margin-top: 20px !important">
                        <q-icon name="keyboard_arrow_right" size="xs" color="grey-8" />유해위험요인 사진
                      </div>
                      <div class="col-12 q-mt-md fm">
                        <c-upload-picture
                          height="200px"
                          :attachInfo="getRiskHazardAttachInfo(props.row.ram4mAssessScenarioId)"
                          :editable="false"/>
                      </div>
                    </div>
                </template>
              </c-card>
            </template>
          </component>
        </template>
      </template>
    </c-table>
    <div class="popup-bottom-bar">
      <!-- <div class="popup-bottom-bar-btngroup">
        <q-btn-group outline >
          <c-btn 
            v-if="editable&&!popupParam.disabled" 
            :isSubmit="isSave"
            :url="saveUrl"
            :param="grid.data"
            mappingType="PUT"
            label="저장" 
            icon="save"
            @beforeAction="saveScenario"
            @btnCallback="saveScenarioCallback" />
        </q-btn-group>
      </div> -->
      <div class="popup-bottom-bar-close">
        <q-btn flat color="gray" icon="arrow_back" @click="closePopUps" />
      </div>
    </div>
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'fmScenario',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        assessPlan: {
          ramStepCd: "",
          processes: [], // 대상공정 목록
          ramRiskAssessmentPlanId: "", // 평가 일련번호
          plantCd: "", // 사업장 코드
          ramTechniqueCd: null, // 평가기법 코드_HAZOP/4m/JSA/CHECKLIST
          ramAssessTypeCd: null, // 평가구분_최초/정기/수시
          assessmentName: "", // 평가명
          assessmentStartDate: "", // 평가시작일
          assessmentEndDate: "", // 평가종료일
          assessmentPeriod: [],
          assessmentYear: "", // 평가년도
          assessmentManageDeptCd: "", // 평가주관 부서 코드
          assessmentManageUserId: "", // 평가주관 담당자 ID
          ramMatrixId: null, // 위험메트릭스 번호
          sopMocId: "", // MOC 일련번호
          remark: "", // 상세내용
          workArea: "", // 작업지역
          regUserId: "", // 작성자 ID
          regUserName: "", // 작성자 ID
          regDtStr: "",
          reviewUserId: "", // 검토자 ID
          reviewDate: "", // 검토일
          approvalUserId: "", // 승인자 ID
          approvalDate: "", // 승인일
          vendorCd: "",
          sopConstructionId: "",
          chgUserId: "", // 수정자 ID
          teams: [], // 평가팀 목록
          occasions: [], // 수시 변경/추가 내역 목록
          conferences: [], // 회의 목록
          relatedDocuments: [], // 관련자료 목록
        },
        process: {
          ramRiskAssessmentPlanId: "", // 평가 일련번호
          processCd: "", // 단위공정 코드
          processName: "", // 단위공정명
          ramProcessAssessStepCd: "", // 평가진행상태
          processExplainFeature: "", // 공정 특징 설명
          assessDeptCd: "", // 평가 부서 코드
          assessDeptName: "",
          assessUserId: "", // 평가 담당자
          assessUserName: "", // 평가 담당자
          workCycleCd: null, // 작업발생주기코드
          workingTime: 0, // 작업시간(1회)
          vendorFlag: 0,
          workMeasurementPlanId: "", // 계획 일련번호
          temperature: "", // 사용온도
          measPlanContent: "",
          workerTypeCd: "",
          shiftFlag: "N",
          workPermitFlag: "N",
          workEduFlag: "N",
          transportTypeCd: null,
          handlingTypeCd: null,
          accidentHistoryFlag: "N",
          accidentHistoryDesc: "",
          nearMissDesc: "",
          heavyTransportTypeCd: "",
          heavyTransportEquip: "",
          heavyManualFlag: "N",
          heavyManualTypeCd: "",
          workEnvMeasureFlag: "N",
          exposureOverFactor: "",
          exposureOverValue: null,
          exposureOverUnit: "",
          specialSafetyEduFlag: "N",
          specialEduTargetCd: "",
          estimationFlag: "", // CHARM 추정 완료여부
          regUserId: "", // 작성자 ID
          chgUserId: "", // 수정자 ID
          equipments: [],
          sops: [],
          drawNodes: [],
          draws: [],
          fmScenarios: [],
          hazopScenarios: [],
          scenarios: [],
          charmResultScenarios: [],
          charmEstimationScenarios: [],
          targets: [],
          thirdScenarios: [],
          safetyInfos: [],
          macinerys: [],
          chemlist: [],
        },
        vendorFlag: false,
        disabled: false
      }),
    },
  },
  data() {
    return {
      grid: {
        merge: [
          { index: 0, colName: 'jobName' },
          { index: 1, colName: 'ram4mRiskHazardClassGroup' },
        ],
        columns: [
          {
            name: 'jobName',
            field: 'jobName',
            label: '단위작업(순서)',
            align: 'left',
            style: 'width:70px',
            sortable: false,
          },
          {
            name: 'ram4mRiskHazardClassName',
            field: 'ram4mRiskHazardClassName',
            label: '구분(4M)',
            align: 'center',
            sortable: false,
          },
          {
            name: 'riskHazardName',
            field: 'riskHazardName',
            label: '유해위험요인',
            align: 'left',
            style: 'width:90px',
            sortable: false,
          },
          // {
          //   name: 'beforeRisk',
          //   field: 'beforeRisk',
          //   label: '개선전 위험도',
          //   align: 'center',
          //   style: 'width:60px',
          //   sortable: false,
          // },
          {
            name: 'afterRisk',
            field: 'afterRisk',
            label: '개선후 위험도',
            align: 'center',
            style: 'width:60px',
            sortable: false,
          },
          {
            name: 'customCol',
            field: 'customCol',
            label: '',
            align: 'center',
            style: 'width:20px',
            type: 'custom',
            sortable: false
          },
        ],
        data: [],
      },
      riskItems: [],
      editable: true,
      isSave: false,
      listUrl: '',
      riskListUrl: '',
      saveUrl: '',
      riskHazardAttachInfoCache: {},
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    // ReadOnly cols
    customReadOnlyCols() { 
      return [
        {
          key: uid(),
          label: '작업', 
          name: 'jobName',
          colClass: 'col-12'
        },
        {
          key: uid(),
          label: '기계,기구 및 설비명[수량]', 
          name: 'equipmentList',
          colClass: 'col-12'
        },
        {
          key: uid(),
          label: '화학물질명[일 취급량, 취급시간]', 
          name: 'chemicalList',
          colClass: 'col-12'
        },
        {
          key: uid(),
          label: '재해형태', 
          name: 'damageTypeNameName',
          colClass: 'col-6'
        },
        {
          key: uid(),
          label: '구분(4M)', 
          name: 'ram4mRiskHazardClassName',
          colClass: 'col-6'
        },
        {
          key: uid(),
          label: '유해위험요인', 
          name: 'riskHazardName',
          colClass: 'col-12'
        },
        {
          key: uid(),
          label: '현재안전조치 현재관리방법', 
          name: 'existingRiskManagementActivities',
          colClass: 'col-12'
        },
        {
          key: uid(),
          label: '빈도', 
          name: 'beforeFrequency',
          group: 'A',
          colClass: 'col-4'
        },
        {
          key: uid(),
          label: '강도', 
          name: 'beforeStrength',
          group: 'A',
          colClass: 'col-4'
        },
        {
          key: uid(),
          label: '위험도', 
          name: 'beforeRisk',
          group: 'A',
          colClass: 'col-4'
        },
        {
          key: uid(),
          label: '개선방향(대책)', 
          name: 'addingRiskManagementActivities',
          colClass: 'col-12'
        },
        {
          key: uid(),
          label: '개선진행여부', 
          name: 'improveFlag',
          colClass: 'col-12'
        },
        {
          key: uid(),
          label: '빈도', 
          name: 'afterFrequency',
          group: 'B',
          colClass: 'col-4'
        },
        {
          key: uid(),
          label: '강도', 
          name: 'afterStrength',
          group: 'B',
          colClass: 'col-4'
        },
        {
          key: uid(),
          label: '위험도', 
          name: 'afterRisk',
          group: 'B',
          colClass: 'col-4'
        },
        {
          key: uid(),
          label: '평가일', 
          name: 'assessDate',
          colClass: 'col-6'
        },
        {
          key: uid(),
          label: '평가자', 
          name: 'assessUserName',
          colClass: 'col-6'
        },
      ]
    },  
    // 개선요청 내용 전달
    requestContentsCols() {
      return ['jobName', 'ram4mRiskHazardClassName', 'riskHazardName'];
    },
    // 개선요청 Component
    imprComponent() {
      return () => import(`${'@/pages/common/ibm/mobileTableImpr.vue'}`);
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.ram.fm.scenario.list.url
      this.riskListUrl = selectConfig.ram.matrix.risk.list.url;
      this.saveUrl = transactionConfig.ram.fm.scenario.save.url
      // code setting
      // list setting
      this.getMatrixRisk();
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        ramRiskAssessmentPlanId: this.popupParam.ramRiskAssessmentPlanId,
        processCd: this.popupParam.processCd,
      }
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    getMatrixRisk() {
      this.$http.url = this.riskListUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        ramMatrixId: this.popupParam.ramMatrixId,
      }
      this.$http.request((_result) => {
        this.riskItems = _result.data;
      },);
    },
    saveScenario(row) {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.$set(row, 'chgUserId', this.$store.getters.user.userId);
              this.$set(row, 'editFlag', 'U');

              this.isSave = !this.isSave
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveScenarioCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getList();
    },
    closePopUps() {
      this.$emit('closePopup')
    },
    // 개선창 닫기 후
    imprChange() {
      this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
    },
    // 개선전/개선후 그룹 타이틀
    isGroupStart(idx) {
      let item = this.customReadOnlyCols[idx];
      if (!item.group) return false;
      return idx === 0 || this.customReadOnlyCols[idx - 1].group !== item.group;
    },
     // 시나리오별 첨부파일 attachInfo 캐시 (매 렌더마다 새 객체가 생성되면
    // c-upload-picture의 watch가 재조회를 유발해 응답 경합이 발생함)
    getRiskHazardAttachInfo(scenarioId) {
      if (!this.riskHazardAttachInfoCache[scenarioId]) {
        this.$set(this.riskHazardAttachInfoCache, scenarioId, {
          taskClassCd: 'RISK_HAZARD',
          taskKey: scenarioId,
        });
      }
      return this.riskHazardAttachInfoCache[scenarioId];
    },
  }
};
</script>
<style lang="sass" scoped>
.fm
  .upload-picture-cover
    padding-bottom: 0px !important
</style>